import {GoodDetailsRec} from "./GoodDetails.ts";

export interface GoodDetailsCardRec {
    goodImg: string,
    goodTitle: string,
    goodDescription: string,
    goodDate: string,
    goodPoints: number,
    logoImg: string,
    companyName: string,
    companyDescription: string,
    companyInfoOnClickButtonAction: () => void,
    handleCloseGoodDetailsModal: () => void
    // clickButtonHandler: () => void,
}

export class GoodDetailsCardBuilder {

    private rec: GoodDetailsCardRec = {
        goodImg: '',
        goodTitle: 'Przykładowy tytuł dobra',
        goodDescription: 'Brak opisu',
        goodDate: '',
        goodPoints: 0,
        logoImg: '',
        companyName: '',
        companyDescription: '',
        companyInfoOnClickButtonAction: () => {},
        handleCloseGoodDetailsModal: () => {},
    };

    private constructor() { }

    static rec(): GoodDetailsCardBuilder {
        return new GoodDetailsCardBuilder();
    }

    goodImg(goodImg: string): GoodDetailsCardBuilder {
        this.rec.goodImg = goodImg;
        return this;
    }

    goodTitle(goodTitle: string): GoodDetailsCardBuilder {
        this.rec.goodTitle = goodTitle;
        return this;
    }

    goodDescription(goodDescription: string): GoodDetailsCardBuilder {
        this.rec.goodDescription = goodDescription;
        return this;
    }

    goodDate(goodDate: string): GoodDetailsCardBuilder {
        this.rec.goodDate = goodDate;
        return this;
    }

    goodPoints(goodPoints: number): GoodDetailsCardBuilder {
        this.rec.goodPoints = goodPoints;
        return this;
    }

    logoImg(logoImg: string): GoodDetailsCardBuilder {
        this.rec.logoImg = logoImg;
        return this;
    }

    companyName(companyName: string): GoodDetailsCardBuilder {
        this.rec.companyName = companyName;
        return this;
    }

    companyDescription(companyDescription: string): GoodDetailsCardBuilder {
        this.rec.companyDescription = companyDescription;
        return this;
    }

    companyInfoOnClickButtonAction(companyInfoOnClickButtonAction: () => void): GoodDetailsCardBuilder {
        this.rec.companyInfoOnClickButtonAction = companyInfoOnClickButtonAction;
        return this;
    }

    handleCloseGoodDetailsModal(handleCloseGoodDetailsModal: () => void): GoodDetailsCardBuilder {
        this.rec.handleCloseGoodDetailsModal = handleCloseGoodDetailsModal;
        return this;
    }

    fromGoodDetailsRec(rec: GoodDetailsRec) : this {
        this.goodImg(rec.image);
        this.goodTitle(rec.shortDescription);
        this.goodDescription(rec.description);
        this.goodDate(rec.goodDate);
        this.goodPoints(rec.score);
        this.logoImg(rec.companyLogo);
        this.companyName(rec.companyName);
        this.companyDescription(rec.companyInformation);
        return this;
    }

    reset(): GoodDetailsCardBuilder {
        this.rec = {
            goodImg: '',
            goodTitle: '',
            goodDescription: '',
            goodDate: '',
            goodPoints: 0,
            logoImg: '',
            companyName: '',
            companyDescription: '',
            companyInfoOnClickButtonAction: () => {},
            handleCloseGoodDetailsModal: () => {},
        };
        return this;
    }

    build(): GoodDetailsCardRec {
        return this.rec;
    }
}
